import { render, staticRenderFns } from "./PhoneCodeYz.vue?vue&type=template&id=53ed33c4&scoped=true"
import script from "./PhoneCodeYz.vue?vue&type=script&lang=js"
export * from "./PhoneCodeYz.vue?vue&type=script&lang=js"
import style0 from "./PhoneCodeYz.vue?vue&type=style&index=0&id=53ed33c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ed33c4",
  null
  
)

export default component.exports